import React from 'react';
import Dropzone from 'react-dropzone';
import FormWrapper from './FormWrapper';

const FormImage = function (props) {
  const {
    image, alt, onDrop, className
  } = props;
  return (
    <FormWrapper name="image" text="Profilbild" type="image">
      <Dropzone
        className="image"
        disablePreview
        onDrop={files => files && files.length === 1 && onDrop(files)}
        multiple={false}
      >
        {image && <img className={className} alt={alt} src={image} />}
        <p>Hier klicken um ein Bild hinzuzufügen.</p>
      </Dropzone>
    </FormWrapper>
  );
};

export default FormImage;



// WEBPACK FOOTER //
// ./src/pages/Helpers/Form/FormImage.js